/*
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 10:12:53
 * @LastEditors: zcy
 * @LastEditTime: 2022-12-07 14:51:52
 */
import Cookies from 'js-cookie'
import * as cookieServ from '@/utils/methods/cookie';
import * as unicodeChangeService from '@/utils/methods/unicode-change';
const state = {
  token: cookieServ.getCookie('token') || null, // 用户认证信息
  userInfo: unicodeChangeService.unicode2Ch(Cookies.get('userInfo')), // 用户信息
  hostLabel: cookieServ.getCookie('label') || 'TABLE',
  returnPath: decodeURIComponent(Cookies.get('returnPath')) || null, // 回退的项目路径
  organList: [], // 分公司的信息
  rootOrganAddress: '', // 顶级公司的地址
  baseId: '', // 基地id
  orgId: '', // 机构id
  rootId: '', // 根机构id
  type: '', // 移动端而管理桌面入口类型（day：日桌面，month：月桌面）
  groupId: '', // 移动端首页区域id
  groupList: [], // 移动端首页区域列表
  menuFlag: {}, // 菜单权限列表
  dayYm: false, // 技术员日桌面育苗权限
  monthYm: false, // 技术员月桌面育苗权限
  generalDayYm: false, // 总经理日桌面育苗权限
  generalMonthYm: false, // 总经理月桌面育苗权限
  historyLength: 0, //  浏览器历史长度（app生产管理页面）
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_HOSTLABEL: (state, hostLabel) => {
    state.hostLabel = hostLabel
  },
  SET_RETURNPATH: (state, returnpath) => {
    state.returnpath = returnpath
  },
  SET_ORGANLIST: (state, organList) => {
    state.organList = organList
  },
  SET_ROOTORGANADDRESS: (state, rootOrganAddress) => {
    state.rootOrganAddress = rootOrganAddress
  },
  SET_BASEID: (state, baseId) => {
    state.baseId = baseId
  },
  SET_ORGID: (state, orgId) => {
    state.orgId = orgId
  },
  SET_ROOTID: (state, rootId) => {
    state.rootId = rootId
  },
  SET_TYPE: (state, type) => {
    state.type = type
  },
  SET_GROUPID: (state, groupId) => {
    state.groupId = groupId
  },
  SET_GROUPLIST: (state, groupList) => {
    state.groupList = groupList
  },
  SET_MENUFLAG: (state, menuFlag) => {
    state.menuFlag = menuFlag
  },
  SET_DAYYM: (state, dayYm) => {
    state.dayYm = dayYm
  },
  SET_MONTHYM: (state, monthYm) => {
    state.monthYm = monthYm
  },
  SET_GENERALDAYYM: (state, generalDayYm) => {
    state.generalDayYm = generalDayYm
  },
  SET_GENERALMONTHYM: (state, generalMonthYm) => {
    state.generalMonthYm = generalMonthYm
  },
  SET_HISTORY_LENGTH: (state, historyLength) => {
    state.historyLength = historyLength
  }
}

const actions = {
  setToken: ({
    commit
  }, token) => {
    commit('SET_TOKEN', token)
  },
  setUserInfo: ({
    commit
  }, userInfo) => {
    // 字符串转对象
    const info = unicodeChangeService.unicode2Ch(Cookies.get('userInfo'));
    if (info) {
      commit('SET_USERINFO', info)
    } else {
      commit('SET_USERINFO', {})
    }
  },
  setHostLabel: ({
    commit
  }, hostLabel) => {
    commit('SET_HOSTLABEL', hostLabel)
  },
  setReturnPath: ({
    commit
  }, returnpath) => {

    // decodeURI解码
    const path = decodeURIComponent(returnpath);
    commit('SET_RETURNPATH', path)
  },
  setDate: ({
    commit
  }, date) => {
    commit('SET_DATE', date)
  },
  setOrganList: (({
    commit
  }, organList) => {
    commit('SET_ORGANLIST', organList)
  }),
  setRootOrganAddress: (({
      commit
    },
    rootOrganAddress
  ) => {
    commit('SET_ROOTORGANADDRESS', rootOrganAddress)
  }),
  setBaseId: (({
    commit
  }, baseId) => {
    commit('SET_BASEID', baseId);
  }),
  setOrgId: (({
    commit
  }, orgId) => {
    commit('SET_ORGID', orgId);
  }),
  setRootId: (({
    commit
  }, rootId) => {
    commit('SET_ROOTID', rootId);
  }),
  setType: ({
    commit
  }, type) => {
    commit('SET_TYPE', type)
  },
  setGroupId: ({
    commit
  }, groupId) => {
    commit('SET_GROUPID', groupId)
  },
  setGroupList: ({
    commit
  }, groupList) => {
    // 替换字段值 groupId -> value, groupName -> text
    const list = groupList.map(re => new Object({
      text: re['groupName'],
      value: re['id']
    }));
    commit('SET_GROUPLIST', list)
  },
  setMenuFlag: ({
    commit
  }, menuFlag) => {
    commit('SET_MENUFLAG', menuFlag)
  },
  setDayYm: ({
    commit
  }, dayYm) => {
    commit('SET_DAYYM', dayYm)
  },
  setMonthYm: ({
    commit
  }, monthYm) => {
    commit('SET_MONTHYM', monthYm)
  },
  setGeneralDayYm: ({
    commit
  }, generalDayYm) => {
    commit('SET_GENERALDAYYM', generalDayYm)
  },
  setGeneralMonthYm: ({
    commit
  }, generalMonthYm) => {
    commit('SET_GENERALMONTHYM', generalMonthYm)
  },
  setHistoryLength: ({
    commit
  }, historyLength) => {
    commit('SET_HISTORY_LENGTH', historyLength)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}